import { toast } from "react-toastify";
import { timeToast } from "../../../Constant";

toast.configure();

const getAsesmenPredikatByList = async (axiosInstance, list) => {
  return await axiosInstance
    .get(`sipeg/asesmen/predikat/${list}`)
    .catch((error) => {
      console.error(error);
      toast.error(`GET Asesmen predikat ${error.message}`, {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: timeToast,
      });
      throw error;
    });
};

export default getAsesmenPredikatByList;
